<vw-header-padding-safe-area></vw-header-padding-safe-area>
<div class="px-4">
  <vw-header-home [user]="user"></vw-header-home>
  <div class="pb-6 w-full">
    <h2 class="text-primary-title text-2xl font-semibold pb-2">
      {{ "home.weather.title" | translate }}
    </h2>
    <div class="flex flex-col gap-2">
      <!-- Wait for user to be loaded to be sure that address-uid is set to localstorage -->
      @if (userLoaded) {
      <vw-weather-card (cardClick)="onWeatherCardClicked()">
      </vw-weather-card>
      }
      @if (!userLoaded) {
      <vw-skeleton-loader [width]="'100%'" [height]="'50px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
      }
      @if (userLoaded) {
      <vw-moon-info-card (cardClick)="onMoonCardClicked()">
      </vw-moon-info-card>
      }
      @if (!userLoaded) {
      <vw-skeleton-loader [width]="'100%'" [height]="'50px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
      }
      @if (userLoaded) {
        <vw-alerts-banner (bannerClick)="onNotificationsClicked()"></vw-alerts-banner>
      }
      <div [style.background-color]="'#9AD6AD' | HexToHsl" (click)="onFeedbackClicked()"
        class=" shadow-lg rounded-xl w-full relative overflow-hidden h-12 flex items-center justify-between">
        <vw-chevron-right-icon
          class="transition-transform duration-300 absolute right-3 top-1/2 -translate-y-1/2 text-[#093935]" />
        <div class="h-full flex items-center px-4 w-56 gap-2">
          <div class="w-8 flex items-center justify-center shrink-0 h-5">
            <vw-message-circle-question-icon class="text-[#093935] h-5" />
          </div>
          <p class="text-sm font-medium whitespace-normal text-[#093935]">
            Feedback
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="pb-6 w-full">
    <h2 class="text-primary-title text-2xl font-semibold pb-2">
      {{ "home.tasks.title" | translate }}
    </h2>
    @if (tasks?.length === 0) {
      <div class="text-grey-700">{{ "home.tasks.unavailable" | translate }}</div>
    }
    @for (task of tasks; track task) {
      <div>
        <vw-task [task]="task"></vw-task>
      </div>
    }
  </div> -->

  <div class="pb-2 w-full">
    @if (hierarchies?.length === 0 && !isLoading) {
    <div class="flex flex-col gap-2">
      <h2 class="text-primary-title text-2xl font-semibold">
        {{ "home.cultivations.empty-title" | translate }}
      </h2>
      <p class="text-grey-600">{{ "home.cultivations.empty" | translate }}</p>
      <div class=" w-full flex flex-col gap-4 items-center">
        <vw-icon-svg [iconUrl]="'assets/images/plant/empty-hierarchies.png'" width="50%"
          class="flex justify-center"></vw-icon-svg>
        <vw-button [label]="'home.cultivations.addPlant'" (click)="onAddPlant()">
        </vw-button>
      </div>
    </div>
    }
    @if (hierarchies?.length > 0 && !isLoading) {
    <div>
      <h2 class="text-primary-title text-2xl font-semibold pb-2">
        {{ "home.cultivations.title" | translate }}
      </h2>
      <vw-user-hierarchies [hierarchies]="hierarchies" [isLoading]="isLoading"></vw-user-hierarchies>
    </div>
    }

    <!-- Articles  -->
    @if (articles?.length > 0) {
    <div class="flex flex-col gap-4 mt-8 mb-28">
      <h2 class="text-primary-title text-2xl font-semibold">
        {{ "home.articles.title" | translate }}
      </h2>
      @for (article of articles; track article) {
      <vw-article [article]="article"></vw-article>
      }
    </div>
    }
  </div>

</div>

<vw-feedback-modal [isOpen]="isFeedbackModalOpen" (onModalClosed)="isFeedbackModalOpen = false"></vw-feedback-modal>
<!-- <vw-report-modal [isOpen]="true"></vw-report-modal> -->